(function () {

    "use strict";

    // Routing
    function routingConfiguration($stateProvider) {

        $stateProvider
            .state("login", {
                url: "/login",
                data: {
                    authorize: false
                },
                template: "<sph-forms-login></sph-forms-login>"
            })
            .state("setPassword", {
                url: "/setPassword/:token",
                template: "<set-password></set-password>"
            })
            .state("resetPassword", {
                url: "/resetPassword",
                template: "<restaurar-password></restaurar-password>"
            })
            .state("user", {
                url: "/user/:id",
                data: {
                    authorize: false
                },
                template: "<sphforms-user></sphforms-user>"
            });

    }

    routingConfiguration.$inject = ["$stateProvider"];

    // OpenIdConnect configurations
    function stsConfiguration(identityServerAuthorizationServiceProvider) {
        identityServerAuthorizationServiceProvider.useBaseUrl("/auth/");
        identityServerAuthorizationServiceProvider.useClientId("roclient");
        identityServerAuthorizationServiceProvider.useClientSecret("secret");
    }

    stsConfiguration.$inject = ["sphForms.idsrvResourceOwnerServiceProvider"];

    // Auth interceptor and token
    function httpProviderConfiguration($httpProvider) {
        $httpProvider.interceptors.push("sphForms.addAuthToken");
        $httpProvider.interceptors.push("sphForms.loginRedirect");
    }

    httpProviderConfiguration.$inject = ["$httpProvider"];

    angular.module("sphForms.auth")
        .config(routingConfiguration)
        .config(stsConfiguration)
        .config(httpProviderConfiguration);

}());